"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6],{

/***/ 1821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthRegistrationForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97346);
/* harmony import */ var react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35005);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18382);
/* harmony import */ var _utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12367);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7544);
/* harmony import */ var react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2_lib_bootstrap_css__WEBPACK_IMPORTED_MODULE_5__);









function AuthRegistrationForm(param) {
    let { onSubmit , onCancel , requestMobilePhone =false  } = param;
    let validationObject = {
        firstName: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        lastName: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        email: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().email().required(),
        password: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required(),
        termsAcceptance: (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .mixed */ .nK)().required()
    };
    if (requestMobilePhone) {
        validationObject.mobilePhone = (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)().required();
    }
    const validationSchema = (0,yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)(validationObject);
    const formik = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormik */ .TA)({
        initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            mobilePhone: ""
        },
        validationSchema,
        onSubmit: async (values)=>{
            try {
                await onSubmit(values);
            } catch (e) {
                formik.setErrors((0,_utils_api__WEBPACK_IMPORTED_MODULE_3__/* .apiErrorsToFormik */ .p)(e));
            } finally{
                formik.setSubmitting(false);
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        onSubmit: formik.handleSubmit,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "firstName",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "First Name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "firstName",
                        isInvalid: formik.errors.firstName,
                        onChange: formik.handleChange
                    }),
                    formik.errors.firstName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.firstName
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "lastName",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Last Name"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "lastName",
                        isInvalid: formik.errors.lastName,
                        onChange: formik.handleChange
                    }),
                    formik.errors.lastName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.lastName
                    })
                ]
            }),
            requestMobilePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "mobilePhone",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Phone Number"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_4___default()), {
                        country: "gb",
                        regions: "europe",
                        containerClass: formik.errors.mobilePhone ? "is-invalid" : "",
                        inputClass: formik.errors.mobilePhone ? "is-invalid" : "",
                        onChange: (value)=>{
                            formik.setFieldValue("mobilePhone", value);
                        }
                    }),
                    formik.errors.mobilePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.mobilePhone
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "email",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "email",
                        type: "email",
                        isInvalid: formik.errors.email,
                        onChange: formik.handleChange
                    }),
                    formik.errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "password",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Label */ .Z.Label, {
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control */ .Z.Control, {
                        name: "password",
                        type: "password",
                        isInvalid: formik.errors.password,
                        onChange: formik.handleChange
                    }),
                    formik.errors.password && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.password
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Group */ .Z.Group, {
                controlId: "termsAcceptance",
                className: "mb-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check */ .Z.Check, {
                    type: "checkbox",
                    name: "termsAcceptance",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check.Input */ .Z.Check.Input, {
                            type: "checkbox",
                            value: true,
                            isInvalid: formik.errors.termsAcceptance,
                            onChange: formik.handleChange
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Check.Label */ .Z.Check.Label, {
                            children: [
                                "I accept the",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat((0,_utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__/* .appUrl */ .G)("legal/terms")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Terms & Conditions"
                                }),
                                " ",
                                "and",
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat((0,_utils_urlHelpers__WEBPACK_IMPORTED_MODULE_7__/* .appUrl */ .G)("legal/privacy")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Privacy Policy"
                                })
                            ]
                        }),
                        formik.errors.termsAcceptance && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Form__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
                            type: "invalid",
                            children: formik.errors.termsAcceptance
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-end",
                children: [
                    onCancel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        variant: "outline-secondary",
                        onClick: onCancel,
                        className: "me-2",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        type: "submit",
                        disabled: formik.isSubmitting,
                        children: "Register"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TutorRequestRequestContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 14 modules
var Form = __webpack_require__(97346);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react-select/async/dist/react-select.esm.js + 38 modules
var react_select_esm = __webpack_require__(5978);
// EXTERNAL MODULE: ./utils/jsonApiClient.js + 1 modules
var jsonApiClient = __webpack_require__(42882);
// EXTERNAL MODULE: ./config/selectTheme.js
var selectTheme = __webpack_require__(34550);
;// CONCATENATED MODULE: ./components/subjects/SearchControl.js




const fetchSubjects = async (inputValue)=>{
    const jsonApi = (0,jsonApiClient/* default */.Z)("subject");
    let params = {
        sort: "name",
        page: {
            size: 1000
        }
    };
    if (inputValue) {
        params.autocomplete = inputValue;
    }
    const { data: subjects  } = await jsonApi.findAll("subject", params);
    return subjects.map((subject)=>{
        return {
            value: subject === null || subject === void 0 ? void 0 : subject.slug,
            label: subject === null || subject === void 0 ? void 0 : subject.name
        };
    });
};
function SubjectsSearchControl(param) {
    let { onChange , subject  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
        cacheOptions: true,
        defaultOptions: true,
        isClearable: true,
        isSearchable: false,
        theme: selectTheme/* default */.Z,
        loadOptions: fetchSubjects,
        placeholder: "Select a subject",
        value: subject,
        onChange: onChange
    });
}

;// CONCATENATED MODULE: ./components/levels/SearchControl.js




const fetchLevels = async (inputValue, subject)=>{
    const jsonApi = (0,jsonApiClient/* default */.Z)("level");
    let filter = {};
    if (subject) {
        filter.for_subject = subject.slug;
    }
    const { data: levels  } = await jsonApi.findAll("level", {
        filter,
        sort: "name",
        page: {
            size: 1000
        }
    });
    return levels.map((level)=>{
        return {
            value: level === null || level === void 0 ? void 0 : level.slug,
            label: level === null || level === void 0 ? void 0 : level.name
        };
    });
};
function LevelsSearchControl(param) {
    let { onChange , level , subject  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.Z, {
        cacheOptions: true,
        defaultOptions: true,
        isClearable: true,
        isSearchable: false,
        theme: selectTheme/* default */.Z,
        loadOptions: (value)=>fetchLevels(value, subject),
        placeholder: "Select a level",
        value: level,
        onChange: onChange
    });
}

// EXTERNAL MODULE: ./node_modules/react-google-autocomplete/index.js
var react_google_autocomplete = __webpack_require__(82625);
;// CONCATENATED MODULE: ./components/locations/FormControl.js




function LocationsFormControl(param) {
    let { location , compact , onChange  } = param;
    const [selectedLocation, setSelectedLocation] = (0,react.useState)({
        formattedAddress: location === null || location === void 0 ? void 0 : location.formattedAddress,
        lat: location === null || location === void 0 ? void 0 : location.lat,
        lon: location === null || location === void 0 ? void 0 : location.lon
    });
    const onLocationSelect = (location)=>{
        if (location) {
            var ref;
            const { lat , lng  } = location === null || location === void 0 ? void 0 : (ref = location.geometry) === null || ref === void 0 ? void 0 : ref.location;
            const formattedAddress = location === null || location === void 0 ? void 0 : location.formatted_address;
            setSelectedLocation({
                formattedAddress,
                lat: lat(),
                lon: lng()
            });
            onChange({
                formattedAddress,
                lat: lat(),
                lon: lng()
            });
        } else {
            setSelectedLocation(null);
            onChange(null);
        }
    };
    const { ref  } = (0,react_google_autocomplete.usePlacesWidget)({
        apiKey: "AIzaSyBXIvH6Ab_sN_jDrqUTaEhgMDZ4So1gD98",
        onPlaceSelected: onLocationSelect,
        options: {
            types: [
                "(regions)"
            ],
            componentRestrictions: {
                country: [
                    "gb"
                ]
            }
        }
    });
    const handleChange = (event)=>{
        const value = event.target.value;
        if (value === "") {
            onLocationSelect(null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
        ref: ref,
        placeholder: "Enter your location",
        defaultValue: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.formattedAddress,
        onChange: handleChange
    });
}

// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(18382);
;// CONCATENATED MODULE: ./components/tutorRequest/Form.js











function TutorRequestForm(param) {
    let { initialValues , onSubmit  } = param;
    const validationSchema = (0,es/* object */.Ry)({
        subject: (0,es/* mixed */.nK)().required("Subject is required."),
        level: (0,es/* mixed */.nK)().required("Level is required."),
        lessonType: (0,es/* string */.Z_)().required(),
        location: (0,es/* object */.Ry)().when("lessonType", {
            is: "in_person",
            then: (schema)=>schema.required("Please enter your location.")
        }).nullable(),
        message: (0,es/* string */.Z_)().required("Please enter a message.")
    });
    const formik = (0,formik_esm/* useFormik */.TA)({
        initialValues,
        validationSchema,
        onSubmit: (values)=>{
            try {
                onSubmit(values);
            } catch (e) {
                formik.setErrors((0,api/* apiErrorsToFormik */.p)(e));
            } finally{
                formik.setSubmitting(false);
            }
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
        onSubmit: formik.handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            controlId: "subject",
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    children: "Subject"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: !!formik.errors.subject ? "is-invalid" : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubjectsSearchControl, {
                                        onChange: (value)=>formik.setFieldValue("subject", value),
                                        subject: formik.values.subject
                                    })
                                }),
                                formik.errors.subject && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                    type: "invalid",
                                    children: formik.errors.subject
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            controlId: "level",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    children: "Level"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: !!formik.errors.level ? "is-invalid" : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LevelsSearchControl, {
                                        onChange: (value)=>formik.setFieldValue("level", value),
                                        level: formik.values.level,
                                        subject: formik.values.subject
                                    })
                                }),
                                formik.errors.level && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                                    type: "invalid",
                                    children: formik.errors.level
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                controlId: "lessonType",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                        children: "Lesson Type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                        type: "radio",
                        name: "lessonType",
                        value: "online",
                        label: "Online",
                        id: "lessonType-online",
                        onChange: formik.handleChange,
                        defaultChecked: formik.values.lessonType === "online"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                        type: "radio",
                        name: "lessonType",
                        value: "in_person",
                        label: "In Person",
                        id: "lessonType-in-person",
                        onChange: formik.handleChange,
                        defaultChecked: formik.values.lessonType === "in_person"
                    }),
                    formik.errors.lessonType && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.lessonType
                    })
                ]
            }),
            formik.values.lessonType === "in_person" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                controlId: "location",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: !!formik.errors.location ? "is-invalid" : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationsFormControl, {
                            location: formik.values.location,
                            onChange: (value)=>formik.setFieldValue("location", value)
                        })
                    }),
                    formik.errors.location && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.location
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                controlId: "message",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                        children: "Message"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                        as: "textarea",
                        rows: 3,
                        ...formik.getFieldProps("message"),
                        isInvalid: !!formik.errors.message
                    }),
                    formik.touched.message && formik.errors.message && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control.Feedback */.Z.Control.Feedback, {
                        type: "invalid",
                        children: formik.errors.message
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "submit",
                    disabled: formik.isSubmitting,
                    children: "Send"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/react-bootstrap-formik/dist/react-bootstrap-formik.esm.js
var react_bootstrap_formik_esm = __webpack_require__(4490);
;// CONCATENATED MODULE: ./components/auth/LoginForm.js




function AuthLoginForm(param) {
    let { onSubmit , onCancel  } = param;
    const validationSchema = (0,es/* object */.Ry)({
        email: (0,es/* string */.Z_)().email().required(),
        password: (0,es/* string */.Z_)().required()
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_bootstrap_formik_esm/* Form */.l, {
        initialValues: {},
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_formik_esm/* Form.Input */.l.Input, {
                    label: "Email",
                    name: "email",
                    type: "email"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_bootstrap_formik_esm/* Form.Input */.l.Input, {
                    label: "Password",
                    name: "password",
                    type: "password"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outline-secondary",
                        onClick: onCancel,
                        className: "me-2",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "submit",
                        children: "Sign In"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/auth/RegistrationForm.js
var RegistrationForm = __webpack_require__(1821);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./utils/auth.js
var auth = __webpack_require__(46180);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(88375);
// EXTERNAL MODULE: ./node_modules/nextjs-google-analytics/dist/index.js
var dist = __webpack_require__(44304);
;// CONCATENATED MODULE: ./components/tutorRequest/RequestContainer.js














function TutorRequestRequestContainer(param) {
    let { subject , level , location , modality , tutorProfile  } = param;
    const [visibleScreen, setVisibleScreen] = (0,react.useState)("tutor_request");
    const [requestAttrs, setRequestAttrs] = (0,react.useState)({
        lessonType: "online"
    });
    const showRequestForm = ()=>setVisibleScreen("tutor_request");
    const { session , isAuthenticated  } = (0,auth/* useSession */.kP)();
    const [error, setError] = (0,react.useState)(null);
    const switchScreen = (screen)=>{
        setError(null);
        setVisibleScreen(screen);
    };
    const submitRequest = async (attrs, authData)=>{
        if (tutorProfile) attrs.fulfilledTutorProfile = tutorProfile;
        setRequestAttrs(attrs);
        if (!!session && isAuthenticated || !!(authData === null || authData === void 0 ? void 0 : authData.access_token)) {
            const accessToken = (session === null || session === void 0 ? void 0 : session.access_token) || authData.access_token;
            const jsonApi = (0,jsonApiClient/* default */.Z)();
            jsonApi.bearer = accessToken;
            const enrichedAttrs = {
                ...attrs,
                subject: await (0,api/* fetchRecordBySlug */.J)("subject", attrs.subject.value),
                level: await (0,api/* fetchRecordBySlug */.J)("level", attrs.level.value)
            };
            if (!enrichedAttrs.profile) {
                const { profile  } = await (0,auth/* getCurrentUser */.ts)(accessToken);
                enrichedAttrs.clientProfile = profile;
            }
            if (enrichedAttrs.clientProfile.type === "tutor-profiles") {
                setError("Only clients can submit tutor requests.");
                return;
            }
            await jsonApi.create("tutor-request", enrichedAttrs);
            if (tutorProfile) {
                (0,dist/* event */.B)("client_contacted_tutor");
            } else {
                (0,dist/* event */.B)("client_contacted_tutorspot");
            }
            switchScreen("success");
        } else {
            switchScreen("registration_form");
        }
    };
    const handleLogin = async (values)=>{
        try {
            const { authData , profile  } = await (0,auth/* signIn */.zB)(values);
            await submitRequest({
                ...requestAttrs,
                clientProfile: profile
            }, authData);
        } catch (e) {
            setError("Your email and/or password are incorrect. Please try again.");
        }
    };
    const handleRegistration = async (attrs)=>{
        const jsonApi = (0,jsonApiClient/* default */.Z)();
        // @Note: No try/catch here as RegistrationForm applies errors to the form
        await jsonApi.create("user", {
            ...attrs,
            roleName: "client"
        }, {
            include: "profile"
        });
        const { email , password  } = attrs;
        await handleLogin({
            email,
            password
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* default */.Z, {
                variant: "danger",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons_index_es/* faExclamationCircle */.RLE,
                        className: "me-1"
                    }),
                    error
                ]
            }),
            visibleScreen === "tutor_request" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorRequestForm, {
                initialValues: requestAttrs,
                subject: subject,
                level: level,
                location: location,
                modality: modality,
                onSubmit: submitRequest
            }),
            visibleScreen === "login_form" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-3",
                        children: "Sign In"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoginForm, {
                        onSubmit: handleLogin,
                        onCancel: showRequestForm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "me-1",
                                children: "Don't have an account yet?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "link",
                                onClick: ()=>switchScreen("registration_form"),
                                children: "Register Now!"
                            })
                        ]
                    })
                ]
            }),
            visibleScreen === "registration_form" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-3",
                        children: "Sign Up to Send Your Request"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrationForm/* default */.Z, {
                        onSubmit: handleRegistration,
                        onCancel: showRequestForm,
                        requestMobilePhone: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "me-1",
                                children: "Already have an account?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "link",
                                onClick: ()=>switchScreen("login_form"),
                                children: "Sign In"
                            })
                        ]
                    })
                ]
            }),
            visibleScreen === "success" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: tutorProfile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-3",
                            children: [
                                "Your message has been sent. ",
                                tutorProfile.firstName,
                                " will be in touch soon."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/tutors/search",
                                    passHref: true,
                                    className: "btn btn-secondary me-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faSearch */.wn1,
                                            className: "me-1"
                                        }),
                                        "Back to search results"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/tutors/".concat(tutorProfile.slug),
                                    className: "btn btn-secondary",
                                    passHref: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faUser */.ILF,
                                            className: "me-1"
                                        }),
                                        "View",
                                        tutorProfile.firstName,
                                        "'s profile"
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "We have received your message and will be in touch shortly to match you with the perfect tutor!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-md-flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/",
                                    className: "btn d-block w-100 btn-secondary me-2 mb-1 mb-md-0",
                                    passHref: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faChevronLeft */.A35,
                                            className: "me-1"
                                        }),
                                        "Back to Home"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/tutors/search",
                                    className: "btn d-block w-100 btn-secondary me-2",
                                    passHref: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons_index_es/* faSearch */.wn1,
                                            className: "me-1"
                                        }),
                                        "Search Tutors"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 18382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ fetchRecordBySlug; },
/* harmony export */   "p": function() { return /* binding */ apiErrorsToFormik; }
/* harmony export */ });
/* harmony import */ var _jsonApiClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42882);

function apiErrorsToFormik(e) {
    let formikErrors = {};
    Object.keys(e).map((field)=>formikErrors[field] = e[field].detail.replace("".concat(field, " - "), ""));
    return formikErrors;
}
async function fetchRecordBySlug(recordType, slug) {
    const jsonApi = (0,_jsonApiClient__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    const { data , errors  } = await jsonApi.findAll(recordType, {
        filter: {
            slug
        }
    });
    if (errors) return errors;
    if (data) return data[0];
}


/***/ })

}]);